import React from 'react';
import { IDocumentsBatchEditingTableProps } from './IDocumentsBatchEditingTableProps';
import { DocumentExecutionService } from '@services/actions/DocumentExecutionService';
import { BatchEditingTableModal } from '@organisms/actions/BatchEditingTableModal/BatchEditingTableModal';

export const DocumentsBatchEditingTableModal: React.FC<IDocumentsBatchEditingTableProps> = (
    props: IDocumentsBatchEditingTableProps,
) => {
    const service = new DocumentExecutionService(props.docId);

    return (
        <BatchEditingTableModal
            source={{
                getScheme: () => service.getBatchEditingTableScheme(props.actionKey, props.docId),
                getData: () => service.getBatchEditingTableData(props.actionKey, props.docId),
                save: (values) => service.saveBatchEditingTableData(props.docId, props.actionKey, values),
            }}
            contentClassName="documents-batch-editing-table-content"
            title={props.title}
            okButtonText={props.okButtonText}
            cancelButtonText={props.cancelButtonText}
            modalSize={props.modalSize}
            completeHandler={props.completeHandler}
        />
    );
};
